import { ThirdwebProvider } from 'thirdweb/react';
import { Buffer } from 'buffer';

// Polyfill Buffer for browser compatibility (required by some Web3 libs)
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
}

/**
 * Web3Provider wraps the thirdweb provider.
 * This is lazy-loaded to prevent WalletConnect from loading on the landing page.
 */
export function Web3Provider({ children }) {
  return <ThirdwebProvider>{children}</ThirdwebProvider>;
}

export default Web3Provider;
